import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Marketing from "../../../containers/modules/marketing/marketing";

export default function MarketingViewRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="marketing"
      index
      element={
        <AccessControl
          name={"Marketing List"}
          auth={authUser}
          component={() => <Marketing />}
        />
      }
    />
  );
}
